module.exports = __webpack_public_path__ + "static/media/selectFoodVoice.873c4fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system/music/selectFoodVoice.mp3
// module id = y18b
// module chunks = 55